/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'
import { handleBlobResponse } from '../../../../client/js/lib/download'
import rest from '../../../../client/js/lib/rest'
import { HalDocument } from '@jalik/hal'

export function deleteInvoiceFileById (id: number) {
  return rest.delete(`/api/invoice-files/${id}`)
}

export function downloadInvoiceFileById (id: number) {
  return rest.get(`/api/invoice-files/${id}/file`)
    .then(handleBlobResponse)
}

export function findManyInvoiceFiles (params?: Record<string, any>) {
  return rest.get(`/api/invoice-files?${stringify(params)}`)
    .then((resp) => resp.json() as HalDocument<{ files: InvoiceFile[] }>)
}

export function uploadInvoiceFile (file: File, tmpRef: string, invoiceId: number) {
  const fd = new FormData()
  fd.append('file', file)
  fd.append('invoiceId', String(invoiceId))
  fd.append('tmpRef', tmpRef)
  return rest.post('/api/invoice-files', { body: fd })
    .then((resp) => resp.json())
}
